var _a;
import { __assign } from "tslib";
import React from 'react';
import { BUTTONS, isValidUrl } from 'wix-rich-content-common';
import InlineSvg from '../../../components/InlineSvg';
import MediaReplaceIcon from '../../../../assets/da-editor/plugins/image/media-replace-icon.inline.svg';
import { PluginToolbarButtons } from '../../../enums';
import LinkIcon from '../../../../assets/da-editor/plugins/image/link-icon.inline.svg';
import { Modals } from '../modals';
var defaultButtons = [
    PluginToolbarButtons.BEST_FIT,
    PluginToolbarButtons.FULL_WIDTH,
    PluginToolbarButtons.ALIGN_LEFT,
    PluginToolbarButtons.ALIGN_RIGHT,
    PluginToolbarButtons.SEPARATOR,
    PluginToolbarButtons.LINK,
    PluginToolbarButtons.SEPARATOR,
    PluginToolbarButtons.REPLACE,
    PluginToolbarButtons.DELETE,
];
var configurableButtons = (_a = {},
    _a[PluginToolbarButtons.BEST_FIT] = {
        keyName: 'sizeContent',
        type: BUTTONS.SIZE_CONTENT,
        mobile: false,
    },
    _a[PluginToolbarButtons.FULL_WIDTH] = {
        keyName: 'sizeFullWidth',
        type: BUTTONS.SIZE_FULL_WIDTH,
        mobile: false,
    },
    _a[PluginToolbarButtons.ALIGN_LEFT] = {
        keyName: 'sizeSmallLeft',
        type: BUTTONS.SIZE_SMALL_LEFT,
        mobile: false,
    },
    _a[PluginToolbarButtons.ALIGN_RIGHT] = {
        keyName: 'sizeSimallRight',
        type: BUTTONS.SIZE_SMALL_RIGHT,
        mobile: false,
    },
    _a[PluginToolbarButtons.LINK] = {
        keyName: 'link',
        type: BUTTONS.EXTERNAL_MODAL,
        icon: function () { return React.createElement(InlineSvg, { icon: LinkIcon }); },
        componentData: {
            title: 'Add Link',
            description: 'Set link URL',
            placeholder: 'https://www.deviantart.com/',
            showRemoveLink: true,
            validateUrl: validateUrl,
            getUrl: getUrl,
            updateUrl: updateUrl,
        },
        modalName: Modals.IMAGE_LINK,
        mobile: false,
    },
    _a[PluginToolbarButtons.SEPARATOR] = {
        keyName: 'separator',
        type: BUTTONS.SEPARATOR,
        mobile: false,
    },
    _a[PluginToolbarButtons.REPLACE] = {
        keyName: 'replace',
        type: BUTTONS.FILES,
        icon: function () { return React.createElement(InlineSvg, { icon: MediaReplaceIcon }); },
        mobile: true,
        tooltipTextKey: 'ReplaceImageButton_Tooltip',
    },
    _a[PluginToolbarButtons.DELETE] = {
        keyName: 'delete',
        type: BUTTONS.DELETE,
        mobile: true,
    },
    _a);
function getUrl(pubsub) {
    var link = pubsub.get('componentData').config.link;
    return link ? link.url : '';
}
function updateUrl(url, pubsub, helpers) {
    var link = url
        ? {
            url: url,
            target: '_blank',
            rel: 'nofollow',
        }
        : null;
    pubsub.update('componentData', { config: { link: link } });
    if (helpers && helpers.onVideoSelected) {
        helpers.onVideoSelected(url, function (data) {
            return pubsub.update('componentData', { metadata: __assign({}, data) });
        });
    }
}
function validateUrl(url) {
    return !url || isValidUrl(url);
}
export default (function (_a) {
    var pluginConfig = _a.pluginConfig, helpers = _a.helpers;
    var buttons = pluginConfig.toolbar || defaultButtons;
    // If we only have one button toggle remove it
    var hasFullWidth = buttons.find(function (b) { return b === PluginToolbarButtons.FULL_WIDTH; }) !== undefined;
    var hasBestFit = buttons.find(function (b) { return b === PluginToolbarButtons.BEST_FIT; }) !== undefined;
    var hasLeftRightAlign = buttons.find(function (b) {
        return b === PluginToolbarButtons.ALIGN_LEFT ||
            b === PluginToolbarButtons.ALIGN_RIGHT;
    });
    var remove = {};
    if (!helpers.featureFlags['editor_experimental'] ||
        (hasFullWidth && !hasBestFit && !hasLeftRightAlign)) {
        remove[PluginToolbarButtons.FULL_WIDTH] = true;
        hasFullWidth = false;
    }
    if (!hasFullWidth && hasBestFit && !hasLeftRightAlign) {
        remove[PluginToolbarButtons.BEST_FIT] = true;
    }
    return buttons
        .filter(function (button) { return !!configurableButtons[button]; })
        .filter(function (button) { return (remove[button] ? false : true); })
        .filter(function (button, idx) {
        return idx === 0 && button === PluginToolbarButtons.SEPARATOR ? false : true;
    })
        .map(function (button) {
        // Allow consumer to conditionally enable/disable the link tool..
        if (pluginConfig.canBeLinked && button === PluginToolbarButtons.LINK) {
            var link = configurableButtons[button];
            link.mapComponentDataToButtonProps = function (componentData) {
                return {
                    disabled: pluginConfig.canBeLinked(componentData) === false,
                };
            };
            return link;
        }
        if (pluginConfig.canBeFullWidth &&
            button === PluginToolbarButtons.FULL_WIDTH) {
            var fullWidth = configurableButtons[button];
            fullWidth.mapComponentDataToButtonProps = function (componentData) {
                return {
                    disabled: pluginConfig.canBeFullWidth(componentData) === false,
                };
            };
        }
        return configurableButtons[button];
    });
});
//# sourceMappingURL=inline-buttons.js.map